import { CustomButton } from "@Modules/core/components";
import { IConsultUnprocessedTransactionsDataTableFilterFormMeta } from '@Modules/transaction/containers/tableHandlers/consultUnprocessedTransactions/ConsultUnprocessedTransactionsDataTableFilterFormMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FaFilter } from "react-icons/fa";
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IConsultUnprocessedTransactionsDataTableFilterFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const ConsultUnprocessedTransactionsDataTableFilterFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>        
        <CC.Box my="4" mb='8'>

          <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
            )}
          </CC.SimpleGrid>

          <CC.Flex justify={'flex-end'}>
            <CustomButton isLoading={isSubmitting} type="submit" mr="4">
              <FaFilter style={{ marginRight: '10px' }} /> Filter
            </CustomButton>
          </CC.Flex>
        </CC.Box>
      </form>
    </>    
  )
}

export default ConsultUnprocessedTransactionsDataTableFilterFormUI;